<!--
    Renders a block in the different display option sizes as an OPE preview.

    * The block is selected with the `BlockComponentSelector` based on its name.
    * Views/Preview/Index.cshtml outputs this component with the content link.

    Compared to the DefaultPage.vue, this does not use the page's friendly URL
    since blocks don't have them. Instead, the content link is used.

    Like `PageComponentSelector`, this page gets the model from the vuex
    store's `epiDataModel` module.
-->

<template>
    <Container v-if="modelLoaded">
        <Row>
            <Column>
                <BlockComponentSelector :model="model"></BlockComponentSelector>
            </Column>
        </Row>
    </Container>
</template>

<script>
import BlockComponentSelector from '@/Scripts/components/BlockComponentSelector.vue';
import { mapState } from 'vuex';
import { UPDATE_MODEL_BY_CONTENT_LINK } from '@/Scripts/store/modules/epiDataModel';
import Container from '@/Scripts/components/atoms/Container/index.vue';
import Row from '@/Scripts/components/atoms/Row/index.vue';
import Column from '@/Scripts/components/atoms/Column/index.vue';

export default {
    props: ['contentLink'],
    computed: mapState({
        model: state => state.epiDataModel.model,
        modelLoaded: state => state.epiDataModel.modelLoaded
    }),
    components: {
        BlockComponentSelector,
        Container,
        Row,
        Column
    },
    created() {
        this.$store.dispatch(UPDATE_MODEL_BY_CONTENT_LINK, this.contentLink);
    }
};
</script>
